
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IDrcxEffectiveTimeModel } from "../../common/models/drcx/DRCXEffectiveTimeModel";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { RouteFromObjectType } from "../../common/utilities/RouteFromObjectType";
import { IReportModel } from "../reporting-data-service/Models";
import restService from "../rest-service/RestService";
import { QuickGraphModel, ITrendDataResultsModel, ITrendDataResultsModelDTO, ITrendingDataRequestModel, ITrendingDataRequestModelDTO, TrendDataResultsModel, IExportOptions, ITrendExportResultsModelDTO, IQuickTrendExportModel, IQuickTrendViewModel, IFileStoreQueryParams, ITrendAdHocDataRequestModel, ITrendingTabularDataRequestModel } from "./Models";
import { GraphReportConfigurationData, IGraphReportConfigDTO } from "./TrendConfigurationModels";

const TrendingDataService = {

    /*

    public getRulesEngineSimulatedData(contextGroupID: number, eLynxObject: Models.IeLynxObjectModel,
        dataRequestOptions: ITrendingDataRequestModel):
        Services.RestPromise<ITrendDataResultsModel> {

        const path: string = [
            "groups",
            contextGroupID,
            "rules-engine",
            "simulation-chart"
        ].join("/");

        return this._restService
            .post<ITrendDataResultsModel, { targetObject: Models.IeLynxObjectModel, dataRequestOptions: ITrendingDataRequestModel }>(path,
                {
                    targetObject: eLynxObject,
                    dataRequestOptions: dataRequestOptions
                })
            .then((data: Services.IRestResponse<ITrendDataResultsModelDTO>) => {

                if (data.entity) {
                    return TrendDataResultsModel.fromDTO(data.entity);
                } else {
                    return null;
                }
            });
    }

    public getConfigurationList(contextGroupID: number, eLynxObject: Models.IeLynxObjectModel): Services.RestPromise<ReportITrendingConfigurationListModel> {

        var path: string = "";

        switch (eLynxObject.objectType) {

            case Enums.eLynxObjectTypeEnum.Device:

                path =
                    [
                        "groups",
                        contextGroupID,
                        "devices",
                        eLynxObject.id,
                        "trending",
                        "configlist"
                    ].join("/");

                break;

            case Enums.eLynxObjectTypeEnum.Group:
                path =
                    [
                        "groups",
                        contextGroupID,
                        "trending",
                        "configlist"
                    ].join("/");

                break;

            case Enums.eLynxObjectTypeEnum.Well:

                path =
                    [
                        "groups",
                        contextGroupID,
                        "wells",
                        eLynxObject.id,
                        "trending",
                        "configlist"
                    ].join("/");

                break;
        }

        return this._restService.get<ReportITrendingConfigurationListModel>(path).then((data: Services.IRestResponse<ReportITrendingConfigurationListModel>) => {
            return new ReportTrendingConfigurationListModel(data.entity);
        });
    }

    //public exportChart(notificationKey: string, contextGroupID: number, eLynxObject: Models.IeLynxObjectModel, fileName: string, height: number, width: number, scale: number, svg: string) {

    //    var path: string = "";

    //    switch (eLynxObject.objectType) {

    //        case Enums.eLynxObjectTypeEnum.Device:

    //            path =
    //                [
    //                    "groups",
    //                    contextGroupID,
    //                    "devices",
    //                    eLynxObject.id,
    //                    "trending",
    //                    "export/chart"
    //                ].join("/");

    //            break;

    //        case Enums.eLynxObjectTypeEnum.Group:
    //            path =
    //                [
    //                    "groups",
    //                    contextGroupID,
    //                    "trending",
    //                    "export/chart"
    //                ].join("/");

    //            break;

    //        case Enums.eLynxObjectTypeEnum.Well:

    //            path =
    //                [
    //                    "groups",
    //                    contextGroupID,
    //                    "wells",
    //                    eLynxObject.id,
    //                    "trending",
    //                    "export/chart"
    //                ].join("/");

    //            break;
    //    }

    //    return this._restService.post(path, <ReportITrendingExportChartRestQueryParams>{
    //        notificationKey: notificationKey,
    //        fileName: fileName,
    //        height: height,
    //        width: width,
    //        scale: scale,
    //        svg: svg
    //    }).then((data: any) => {
    //        return data.entity;
    //    });
    //}

    public exportData(notificationKey: string, contextGroupID: number, eLynxObject: Models.IeLynxObjectModel, mimeType: Enums.ApplicationMimeTypesEnum, windowWidth: number, windowHeight: number,
        startDateTime?: Date, endDateTime?: Date, configurationID?: number) {

        var path: string = "";

        switch (eLynxObject.objectType) {

            case Enums.eLynxObjectTypeEnum.Device:

                path =
                    [
                        "groups",
                        contextGroupID,
                        "devices",
                        eLynxObject.id,
                        "trending",
                        "export/data"
                    ].join("/");

                break;

            case Enums.eLynxObjectTypeEnum.Group:
                path =
                    [
                        "groups",
                        contextGroupID,
                        "trending",
                        "export/data"
                    ].join("/");

                break;

            case Enums.eLynxObjectTypeEnum.Well:

                path =
                    [
                        "groups",
                        contextGroupID,
                        "wells",
                        eLynxObject.id,
                        "trending",
                        "export/data"
                    ].join("/");

                break;
        }

        return this._restService.post(path, <ReportITrendingExportDataRestQueryParams>{
            configurationID: configurationID,
            endDateTime: endDateTime,
            mimeType: mimeType,
            notificationKey: notificationKey,
            startDateTime: startDateTime,
            windowHeight: windowHeight,
            windowWidth: windowWidth
        }).then((data: any) => {
            return data.entity;
        });
    }

    public getPendingQuickTrendingCount(contextGroupID: number, configurationID?: number): RestPromise<number> {         
        var path: string =
            [
                "servicebusmonitor",
                "quicktrendexportermsg",
                "pendingmsgcount",
                contextGroupID,
                configurationID
            ].join("/");

        return this._restService.get(path, null).then((data: any) => {
            return data.entity;
        });
    }

    public getQuickTrendingExportData(contextGroupID: number, filestoreID: number):
        Services.RestPromise<ReportIQuickTrendViewModel> {

        var path: string =
            [
                "groups",
                contextGroupID,
                "trending/filestore/data"
            ].join("/");

        var getQueryParams: Models.IDowloadFileStoreQueryParams = {
            filestoreID: filestoreID
        };

        return this._restService.get<ReportIQuickTrendViewModel, Models.IDowloadFileStoreQueryParams>(path, getQueryParams).then((data: Services.IRestResponse<ReportIQuickTrendViewModel>) => {
            return data.entity;
        });
    }

    public getQuickGraphSelections(contextGroupID: number, eLynxObject: Models.IeLynxObjectModel): Services.RestPromise<ReportIQuickGraphModel> {

        var path: string = "";

        switch (eLynxObject.objectType) {

            case Enums.eLynxObjectTypeEnum.Device:

                path =
                    [
                        "v2",
                        "groups",
                        contextGroupID,
                        "devices",
                        eLynxObject.id,
                        "trending",
                        "quickgraph",
                        "selections"
                    ].join("/");

                break;

            case Enums.eLynxObjectTypeEnum.Group:
                path =
                    [
                        "v2",
                        "groups",
                        contextGroupID,
                        "trending",
                        "quickgraph",
                        "selections"
                    ].join("/");

                break;

            case Enums.eLynxObjectTypeEnum.Well:

                path =
                    [
                        "v2",
                        "groups",
                        contextGroupID,
                        "wells",
                        eLynxObject.id,
                        "trending",
                        "quickgraph",
                        "selections"
                    ].join("/");

                break;
         }

        return this._restService.get(path).then((data: Services.IRestResponse<ReportIQuickGraphModel>) => {
            return data.entity;
        });
    }
 */
    getEffectiveDates: async function (
        contextGroupID: number,
        configurationID: number,
        signal?: AbortSignal
    ): Promise<IDrcxEffectiveTimeModel> {

        const path: string = `groups/${contextGroupID}/trending/${configurationID}/effectivedates`;
        const result = await restService.get<IDrcxEffectiveTimeModel>(path, signal);
        return result.data;
    },
    getFileStoreData: async function (contextGroupID: number, fileStoreID: number, signal?: AbortSignal):
        Promise<ITrendDataResultsModel> {

        const path: string = `groups/${contextGroupID}/trending/filestore/data`;

        const getQueryParams: IFileStoreQueryParams = {
            filestoreID: fileStoreID
        };

        const result = await restService.get<ITrendDataResultsModel, IFileStoreQueryParams>(path, signal, getQueryParams);
        return result.data;
    },
    getGraphReportOnscreenData: async function (contextGroupID: number, fileStoreID: number, signal?: AbortSignal):
        Promise<IQuickTrendViewModel> {

        const path: string = `groups/${contextGroupID}/trending/filestore/data`;

        const getQueryParams: IFileStoreQueryParams = {
            filestoreID: fileStoreID
        };

        const result = await restService.get<IQuickTrendViewModel, IFileStoreQueryParams>(path, signal, getQueryParams);
        return result.data;
    },
    exportGraphData: async function (
        contextGroupID: number,
        eLynxObject: IeLynxObject,
        exportOptions: IExportOptions,
        signal?: AbortSignal
    ): Promise<ITrendExportResultsModelDTO | undefined> {

        const path = eLynxObject.objectType === eLynxObjectTypeEnum.Group ?
            `groups/${contextGroupID}/trending/export/data` :
            `groups/${contextGroupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/trending/export/data`;

        const result = await restService.post<IExportOptions, ITrendExportResultsModelDTO>(path, exportOptions, signal);
        return result.data;
    },
    exportGraphReport: async function (
        groupID: number,
        exportOptions: IExportOptions,
        signal?: AbortSignal
    ): Promise<void> {

        const path: string = `groups/${groupID}/graph-report/export`;
        await restService.post<IExportOptions, IQuickTrendExportModel>(path, exportOptions, signal);
    },
    getData: async function (
        contextGroupID: number,
        eLynxObject: IeLynxObject,
        dataRequestOptions: ITrendingDataRequestModel,
        signal?: AbortSignal):
        Promise<ITrendDataResultsModel | undefined> {

        let data: ITrendDataResultsModel | undefined;

        const targetObject: IeLynxObject = {
            ...eLynxObject,
            objectType: eLynxObject.objectType === eLynxObjectTypeEnum.Tank ?
                eLynxObjectTypeEnum.Device :
                eLynxObject.objectType
        };

        const path = eLynxObject.objectType === eLynxObjectTypeEnum.Group ?
            `groups/${contextGroupID}/trending/data` :
            `groups/${contextGroupID}/${RouteFromObjectType(targetObject)}/${eLynxObject.id}/trending/data`;

        if (dataRequestOptions.toDTO) {
            const response = await restService.post<ITrendingDataRequestModelDTO, ITrendDataResultsModelDTO>(path, dataRequestOptions.toDTO(), signal);
            if (response.data) {
                const model = TrendDataResultsModel.fromDTO(response.data);

                // If commenting out the code line below causes a bug it is Dan's fault. 
                //  The reason why the Series index property is the
                //  reverse order coming from the server API call is because the z-index for Highcharts was the reverse of ChartFX.
                //  When the Series lines had a different z-index comparing the charts they looked completely different.
                //  Kurt though

                // fix bad index values, this causes the chart to mix up data and not display all of the yaxis
                // model?.trendViewModels?.forEach(o => o.chartOptions?.series?.forEach(v => v.index = v.legendIndex));

                return model;
            }
        }

        return data;
    },
    getGraphReportConfigurationList: async function (contextGroupID: number, signal?: AbortSignal):
        Promise<GraphReportConfigurationData> {

        const path: string = `groups/${contextGroupID}/graph-report/configlist`;

        const result = await restService.get<IGraphReportConfigDTO>(path, signal);
        return new GraphReportConfigurationData(result.data);
    },
    getQuickGraphSelections: async function (contextGroupID: number, eLynxObject: IeLynxObject, signal?: AbortSignal):
        Promise<QuickGraphModel> {

        const path = eLynxObject.objectType === eLynxObjectTypeEnum.Group ?
            `groups/${contextGroupID}/trending/quickgraph/selections` :
            `groups/${contextGroupID}/${RouteFromObjectType(eLynxObject)}/${eLynxObject.id}/trending/quickgraph/selections`;

        const response = await restService.get<QuickGraphModel>(path, signal);
        return response.data;
    },
    getPendingGraphReportCount: async function (groupID: number, configurationID?: number, signal?: AbortSignal):
        Promise<number> {

        const path = `groups/${groupID}/servicebusmonitor/quicktrendexportermsg/pendingmsgcount/${configurationID ?? -1}`;

        const response = await restService.get<number>(path, signal);
        return response.data;
    },
    getDataAdHoc2: async function (
        contextGroupID: number,
        eLynxObject: IeLynxObject,
        dataRequestOptions: ITrendAdHocDataRequestModel,
        signal?: AbortSignal
    ): Promise<ITrendDataResultsModel> {

        var path: string = "";

        switch (eLynxObject.objectType) {

            // Devices and Tanks use the same route and the type is handled on the server.
            case eLynxObjectTypeEnum.Device:
            case eLynxObjectTypeEnum.Tank:

                path = `v2/groups/${contextGroupID}/devices/${eLynxObject.id}/trending/data/adhoc`;
                break;

            case eLynxObjectTypeEnum.Group:
                path = `v2/groups/${contextGroupID}/trending/data/adhoc`;
                break;

            case eLynxObjectTypeEnum.TankBattery:

                path = `v2/groups/${contextGroupID}/tankbatteries/${eLynxObject.id}/trending/data/adhoc`;
                break;

            case eLynxObjectTypeEnum.Well:

                path = `v2/groups/${contextGroupID}/wells/${eLynxObject.id}/trending/data/adhoc`;
                break;
        }

        const response = await restService.post<ITrendAdHocDataRequestModel, ITrendDataResultsModel>(
            path,
            dataRequestOptions,
            signal
        );

        return response.data;
    },

    getTabularData: async function (
        groupID: number,
        targetObject: IeLynxObject,
        configurationID: number,
        startTime?: Date,
        endTime?: Date,
        signal?: AbortSignal
    ): Promise<IReportModel> {

        const path = targetObject.objectType === eLynxObjectTypeEnum.Group
            ? `groups/${groupID}/trending/tabulardata`
            : `groups/${groupID}/${RouteFromObjectType(targetObject)}/${targetObject.id}/trending/tabulardata`;

        const requestOptions = {
            configurationID,
            startTime,
            endTime
        };

        const response = await restService.post<ITrendingTabularDataRequestModel, IReportModel>(
            path, 
            requestOptions, 
            signal
        );

        return response.data;
    }
};

export default TrendingDataService;